import { render, staticRenderFns } from "./Sildebar.vue?vue&type=template&id=2cf077ac&scoped=true&"
import script from "./Sildebar.vue?vue&type=script&lang=js&"
export * from "./Sildebar.vue?vue&type=script&lang=js&"
import style0 from "./Sildebar.vue?vue&type=style&index=0&id=2cf077ac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf077ac",
  null
  
)

export default component.exports